// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_39efa1', '__Inter_Fallback_39efa1'","fontStyle":"normal"},"className":"__className_39efa1"};